import { createAgentsBalanceReportSlice } from "../sub-slices/reports/agentsBalanceReportSlice";
import { createALLCallHistorySlice } from "../sub-slices/reports/ALLCallHistorySlice";
import { createBalanceReportSlice } from "../sub-slices/reports/balanceReportSlice";
import { createBusinessCompanySaleReportSlice } from "../sub-slices/reports/BusinessCompanySaleReportSlice";
import { createCallHistoryReasonSlice } from "../sub-slices/reports/CallhistoryReasonSlice";
import { createCallHistoryReportSlice } from "../sub-slices/reports/CallHistoryReportSlice";
import { createCallHistorySlice } from "../sub-slices/reports/CallHistorySlice";
import { createCallItemsSlice } from "../sub-slices/reports/CallItemsSlice";
import { createCallReasonReportSlice } from "../sub-slices/reports/CallReasonReportSlice";
import { createCallStatusReportSlice } from "../sub-slices/reports/CallStatusReportSlice";
import { createDeliveryStateHistoryReportSlice } from "../sub-slices/reports/deliveryStateHistoryReportSlice";
import { createDoneCallHistorySlice } from "../sub-slices/reports/DoneCallHistorySlice";
import { createEndorsementPendingPaymentSlice } from "../sub-slices/reports/endorsementPendingPayment";
import { createEndorsementRejectedSlice } from "../sub-slices/reports/endorsementRejected";
import { createEndorsementUnderReviewSlice } from "../sub-slices/reports/endorsementUnderReview";
import { createGraphsReportSlice } from "../sub-slices/reports/graphsReportSlice";
import { createInsuranceDetailsReportSlice } from "../sub-slices/reports/InsuranceDetailsReportSlice";
import { createIssueEndorsementSlice } from "../sub-slices/reports/issueEndorsementSlice";
import { createLoginReportSlice } from "../sub-slices/reports/LoginReportSlice";
import { createMarketersBalanceReportSlice } from "../sub-slices/reports/marketersBalanceReportSlice";
import { createOtpReportSlice } from "../sub-slices/reports/otpReportSlice";
import { createPageLogReportSlice } from "../sub-slices/reports/PageLogReportSlice";
import { createPendingPaymentSlice } from "../sub-slices/reports/PendingPaymentSlice";
import { createPurchasesReportSlice } from "../sub-slices/reports/purchasesReportSlice";
import { createRejectedReportSlice } from "../sub-slices/reports/rejectedReportSlice";
import { createRenewalReportSlice } from "../sub-slices/reports/renewalReportSlice";
import { createRequestReportSlice } from "../sub-slices/reports/RequestReportSlice";
import { createReturnedReportSlice } from "../sub-slices/reports/returnedReportSlice";
import { createSalesSlice } from "../sub-slices/reports/salesSlice";
import { createSmsReportSlice } from "../sub-slices/reports/SmsReportSlice";
import { createSummaryReportSlice } from "../sub-slices/reports/SummaryReportSlice";
import { createSupportReportSlice } from "../sub-slices/reports/SupportReportSlice";
import { createTicketInfoReportSlice } from "../sub-slices/reports/TicketInfoReportSlice";
import { createTicketReportSlice } from "../sub-slices/reports/TicketReportSlice";
import { createUnderReviewReportSlice } from "../sub-slices/reports/underReviewReportSlice";
import { createUserBusinessReportSlice } from "../sub-slices/reports/UserBusinessReportSlice";
import { createMyCallHistoriesSlice } from "../sub-slices/reports/MyCallHistoriesSlice";
import { createWalletSlice } from "../sub-slices/reports/WalletSlice";
import { createCrmCallsSlice } from "../sub-slices/reports/CrmCallsSlice";
import { createUserReceiptDetailsSlice } from "../sub-slices/reports/UserReceiptDetails";
import { createEndorsementInfoSlice } from "../sub-slices/reports/EndorsementInfoSlice";
import { createUserReceiptSlice } from "../sub-slices/reports/UserReceiptSlice";
import { createShowLogsRequestEventSlice } from "../sub-slices/reports/ShowLogsRequestEventSlice";
import { create } from "zustand";
import { createCrmEndorsementsSlice } from "../sub-slices/reports/CrmEndorsementsSlice";
import { createCanceledReportSlice } from "../sub-slices/reports/canceledReportSlice";
import { createPlaqueReportSlice } from "../sub-slices/reports/createPlaqueReportSlice";
import { createWhiteLableSettelmentFundReport } from "../sub-slices/reports/whiteLableSettelmentFundReport";
import { createReferralReportSlice } from "../sub-slices/reports/referralReportSlice";
import { createPromoterUsersReportSlice } from "../sub-slices/reports/createPromoterUsersReportSlice";
import { createCrmSmsSlice } from "../sub-slices/reports/CrmSmsSlice";
import { createInstallmentSlice } from "../sub-slices/reports/installmentSlice";
import { createUserEndorsementReportSlice } from "../sub-slices/reports/userEndorsementReportSlice";
import { createUserInfoSlice } from "../sub-slices/reports/createUserInfoSlice";

export const useReportsStore = create((set, get) => ({
    ...createSummaryReportSlice(set, get),
    ...createUnderReviewReportSlice(set, get),
    ...createInsuranceDetailsReportSlice(set, get),
    ...createSupportReportSlice(set, get),
    ...createUnderReviewReportSlice(set, get),
    ...createBusinessCompanySaleReportSlice(set, get),

    ...createEndorsementRejectedSlice(set, get),
    ...createEndorsementUnderReviewSlice(set, get),
    ...createEndorsementPendingPaymentSlice(set, get),
    ...createPendingPaymentSlice(set, get),
    ...createOtpReportSlice(set, get),
    ...createRenewalReportSlice(set, get),

    ...createSalesSlice(set, get),
    ...createInstallmentSlice(set, get),
    ...createIssueEndorsementSlice(set, get),
    ...createRejectedReportSlice(set, get),
    ...createCanceledReportSlice(set, get),
    ...createGraphsReportSlice(set, get),
    ...createMarketersBalanceReportSlice(set, get),
    ...createAgentsBalanceReportSlice(set, get),
    ...createBalanceReportSlice(set, get),
    ...createPurchasesReportSlice(set, get),
    ...createReferralReportSlice(set, get),
    ...createDeliveryStateHistoryReportSlice(set, get),
    ...createReturnedReportSlice(set, get),
    ...createPageLogReportSlice(set, get),
    ...createShowLogsRequestEventSlice(set, get),

    ...createUserBusinessReportSlice(set, get),
    ...createSmsReportSlice(set, get),
    ...createRequestReportSlice(set, get),
    ...createLoginReportSlice(set, get),
    ...createTicketReportSlice(set, get),
    ...createTicketInfoReportSlice(set, get),
    ...createCallHistoryReportSlice(set, get),
    ...createCallStatusReportSlice(set, get),
    ...createCallReasonReportSlice(set, get),

    ...createCallHistorySlice(set, get),
    ...createCallHistoryReasonSlice(set, get),
    ...createDoneCallHistorySlice(set, get),
    ...createCallItemsSlice(set, get),
    ...createALLCallHistorySlice(set, get),

    ...createMyCallHistoriesSlice(set, get),
    ...createWalletSlice(set, get),
    ...createCrmCallsSlice(set, get),
    ...createCrmEndorsementsSlice(set, get),
    ...createUserReceiptSlice(set, get),
    ...createEndorsementInfoSlice(set, get),
    ...createUserReceiptDetailsSlice(set, get),

    ...createPlaqueReportSlice(set, get),
    ...createWhiteLableSettelmentFundReport(set, get),
    ...createPromoterUsersReportSlice(set, get),
    ...createUserInfoSlice(set, get),

    ...createCrmSmsSlice(set, get),
    ...createUserEndorsementReportSlice(set, get),
}))